import { runOnFeatureInit } from '@frontend/vanilla/core';

import { TracingBootstrapService } from './tracing-bootstrap.service';

export function provide() {
    return [runOnFeatureInit(TracingBootstrapService)];
}
